import translate from "src/lib/translate";
import FactorySignupCustomCampaign from "../FactorySignupCustomCampaign";
import HtmlParser from "src/lib/HtmlParser";

const StateOfGeorgiaIneligibilityContent = (
  props: FactorySignupCustomCampaign
) => {
  const number = props.getContactNumber();

  const withReason = translate("ineligibility.reasonText", {
    context: "BIRTH-DATE-state-of-georgia",
    phoneNumber: number.displayNumber,
    telLink: number.telLink
  });

  return (
    <div>
      <nine-spacer s="md"></nine-spacer>
      {new HtmlParser(withReason).toJsx()}
    </div>
  );
};

export default StateOfGeorgiaIneligibilityContent;
